import { Component, computed, inject, input } from '@angular/core'
import { UsersService } from 'src/app/services'

@Component({
  selector: 'app-user-preview',
  imports: [],
  templateUrl: './user-preview.component.html',
  styleUrl: './user-preview.component.scss',
})
export class UserPreviewComponent {
  userId = input<number>()

  private usersService = inject(UsersService)
  user = computed(() => this.usersService.getUserById(this.userId()))
}
